import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';

export const createForm = (data: ISurveyBuilder): FormGroup => {
  return new FormGroup({
    question: new FormControl(data.question, [Validators.required, Validators.maxLength(500)]),
    positive: new FormControl(data.positive, [Validators.required, Validators.maxLength(500)]),
    answerType: new FormControl({ value: data.answerType, disabled: true }, [Validators.required]),
    negative: new FormControl(data.negative, [Validators.required, Validators.maxLength(500)]),
    options: new FormArray(
      data.options.map(item => {
        return new FormGroup({
          text: new FormControl({ value: item.text, disabled: true }, [Validators.required, Validators.maxLength(100)]),
          id: new FormControl(item.id),
          order: new FormControl(item.order)
        });
      })
    )
  });
};

export interface ISurveyBuilder {
  id: number;
  question: string;
  positive: string;
  negative: string;
  answerType: number;
  options: {
    id: number;
    order: number;
    text: string;
  }[];
}
